<template>
  <w-sliding-popup :type="slidingPopupType" ref="slidingPopup" :title="popupTitle" width="800px" :default-content="false" @open="open" @close="close" append-to-body modal-append-to-body>
    <div class="body-content" slot="content" style="height:100%;">
      <el-row style="height:calc(50% - 29px);">
        <div class="title-h4 title-bar">수집  설정 키 목록</div>
        <el-table-wrapper style="height:calc(100% - 26px);" :fit-height="true"  :data="mappingKeyTableData" :columns="mappingKeyTableColumns" ref="mappingKeyTable" @selection-change="changeCheckedRow"
        :show-search-tool="false" :show-custom-header="true" :pagination="false">
        </el-table-wrapper>
      </el-row>
      <el-row type="flex" justify="center" style="margin:20px 0 10px 0">
        <el-button class="mr-r4" @click="clickUpButton" :disabled="checkedSelectedMappingKeyList.length === 0"><i class="fas fa-angle-up"></i></el-button>
        <el-button @click="clickDownButton" :disabled="checkedMappingKeyList.length === 0"><i class="fas fa-angle-down"></i></el-button>
      </el-row>
      <el-row style="height:calc(50% - 29px);">
        <div class="title-h4 title-bar">[{{sourceName}}] 설정키 목록</div>
        <el-table-wrapper style="height:calc(100% - 26px);" :fit-height="true" :data="selectedMappingKeyTableData" :columns="mappingKeyTableColumns" :column-default="columnDefault" ref="selectedMappingKeyTable"
        @selection-change="changeSelectedCheckedRow" :show-search-tool="false" :show-custom-header="true" :pagination="false">
        </el-table-wrapper>
      </el-row>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="saveButton">저장</el-button>
      <el-button size="large" @click="cancelButton">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { concat, differenceBy, cloneDeep } from 'lodash';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import RuleSettingsAPI from '@/api/settings/common/rule-settings';

export default {
  name: 'WMappingKeySettingPopup',
  props: {
    slidingPopupType: String,
    selectedRscGetdataSource: Object,
    selectedMappingKeyList: Array,
  },
  data() {
    return {
      popupTitle: null,
      checkedMappingKeyList: [],
      checkedSelectedMappingKeyList: [],
      mappingKeyTableData: [],
      selectedMappingKeyTableData: [],
      columnDefault,
      mappingKeyTableColumns: [
        {
          type: 'selection',
          width: 35,
        },
        {
          prop: 'mappingKey',
          label: '설정 키',
          searchable: true,
        },
        {
          prop: 'mappingKeyName',
          label: '설정 키 명',
          searchable: true,
        },
        {
          prop: 'mappingKeyDesc',
          label: '설명',
          searchable: true,
        },
      ],
    };
  },
  computed: {
    sourceName() {
      return this.selectedRscGetdataSource ? getValueAfterCheckEmpty(this.selectedRscGetdataSource.sourceName) : EMPTY_TEXT;
    },
  },
  methods: {
    open() {
      this.popupTitle = `[${this.sourceName}] 수집 설정 키 관리`;
      RuleSettingsAPI.getMappingKeyList().then((response) => {
        const mappingKeyList = response.data.data;
        const selectedMappingKeyList = this.selectedMappingKeyList;
        const result = differenceBy(mappingKeyList, selectedMappingKeyList, 'mappingKey');
        this.mappingKeyTableData = cloneDeep(result);
        this.selectedMappingKeyTableData = cloneDeep(selectedMappingKeyList);
      });
    },
    close() {
      this.mappingKeyTableData = [];
      this.selectedMappingKeyTableData = [];
      this.$emit('re-load');
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    saveButton() {
      const params = {
        rscGetmethodId: this.selectedRscGetdataSource.rscGetmethodId,
        rscGetdataTypeId: this.selectedRscGetdataSource.rscGetdataTypeId,
        sourceId: this.selectedRscGetdataSource.sourceId,
        mappingKeyRscGetdataList: this.selectedMappingKeyTableData,
      };

      const target = `[${this.sourceName}] 수집 설정 키`;
      const action = msgUtil.action.MODIFY;
      RuleSettingsAPI.updateMappingKeyRscGetdataList(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.closePopup();
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    cancelButton() {
      this.closePopup();
    },
    changeCheckedRow(list) {
      this.checkedMappingKeyList = list;
    },
    changeSelectedCheckedRow(list) {
      this.checkedSelectedMappingKeyList = list;
    },
    clickUpButton() {
      const checkedList = this.checkedSelectedMappingKeyList;
      const selectedMappingKeyList = differenceBy(this.selectedMappingKeyTableData, checkedList, 'mappingKey');
      const mappingKeyList = concat(this.mappingKeyTableData, checkedList);
      this.mappingKeyTableData = mappingKeyList;
      this.selectedMappingKeyTableData = selectedMappingKeyList;
    },
    clickDownButton() {
      const checkedList = this.checkedMappingKeyList;
      const mappingKeyList = differenceBy(this.mappingKeyTableData, checkedList, 'mappingKey');
      const selectedMappingKeyList = concat(this.selectedMappingKeyTableData, checkedList);
      this.mappingKeyTableData = mappingKeyList;
      this.selectedMappingKeyTableData = selectedMappingKeyList;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/CollectionJudgementRuleSettings/popup/MappingKeySettingPopup.vue